import { useQuery } from "@tanstack/react-query"

import { GetEcobalyseMaterialTypesResponseDto } from "@tfg/types/schemas/modules/lifeCycleAnalysis/dtos/get-ecobalyse-material-types.response.dto"

import { httpClient } from "~/backend/axios"

export const useGetEcobalyseMaterialTypesQuery = () =>
  useQuery(["ecobalyse", "materialTypes"], async () => {
    const res = await httpClient.get<GetEcobalyseMaterialTypesResponseDto>(
      "/lca/get-ecobalyse-material-types"
    )

    return res.data
  })
